// 导入自己需要的组件
import { Switch,Popover,Select,Option } from 'element-ui'
const element = {
    install: function (Vue) {
        Vue.use(Switch)
        Vue.use(Popover)
        Vue.use(Select)
        Vue.use(Option)
    }
}
export default element
